<template>
  <v-row class="align-center" style="height:100%">
    <v-col cols="7" style="text-align: right;">
      <img src="@/assets/client_top/client_top.png" height="500px" style="margin-left: -1000px; padding-right: 60px" >
    </v-col>
    <v-col cols="5">
      <v-row>
        <v-col cols="12">
          <v-img max-width="240px" src="@/assets/connect_navy.svg" contain></v-img>
        </v-col>
        <v-col cols="12" class="text">求人企業向けログイン</v-col>
        <v-col cols="12">
          <v-btn
              class="font-weight-bold"
              depressed
              height="60px"
              width="200px"
              style="font-size: 24px; border-radius: 10px"
              color="primary"
              @click="login"
          >ログイン
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import ComponentMixin from '../../ComponentMixin';


  export default {
    mixins: [ComponentMixin],
    type: "page",
    name: "ClientTopPage",
    components: {
    },
    computed: {
    },
    methods: {
      login () {
        this.$auth.loginWithRedirect({
          ui_locales: this.$i18n.locale,
        });
      },
    },
    watch: {
      "$auth.user": {
        handler: function(user) {
          if (user) {
            this.go('/clients/jobs')
          }
        }
      }
    }
  }
</script>

<style scoped lang="sass">
  .text
    color: #777777
    font-size: 24px
</style>
